import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Catalogs_ds_material_catalog_source_material_project_subscribers_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { source_material_id: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, MaterialCatalogSourceMaterialId?: number, ModifiedSysDateTime?: string, Project?: { Id?: number, LookupCode?: string, Name?: string, OwnerId?: number, Owner?: { LookupCode?: string, Name?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.source_material_id)) {
      missingRequiredInParams.push('\'source_material_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Catalogs/datasources/ds_material_catalog_source_material_project_subscribers_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { source_material_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, MaterialCatalogSourceMaterialId?: number, ModifiedSysDateTime?: string, Project?: { Id?: number, LookupCode?: string, Name?: string, OwnerId?: number, Owner?: { LookupCode?: string, Name?: string } } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.source_material_id)) {
      missingRequiredInParams.push('\'source_material_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Catalogs/datasources/ds_material_catalog_source_material_project_subscribers_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { source_material_id: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, MaterialCatalogSourceMaterialId?: number, ModifiedSysDateTime?: string, Project?: { Id?: number, LookupCode?: string, Name?: string, OwnerId?: number, Owner?: { LookupCode?: string, Name?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.source_material_id)) {
      missingRequiredInParams.push('\'source_material_id\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Catalogs/datasources/ds_material_catalog_source_material_project_subscribers_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      source_material_id: number    }) {
        if(isNil(inParams.source_material_id)) {
          return true; 
        }
      return false;
    }
}
